/**
 * Get a search parameter value from the current URL.
 * @param {string} key - The parameter name to look up.
 * @returns {string|null} The parameter value, or null if not present.
 */
export function getParam(key) {
	const params = new URLSearchParams(window.location.search);

	if (!params) return null;

	return params.get(key);
}

/**
 * Get a search parameter value as an integer.
 * @param {string} key - The parameter name to look up.
 * @returns {number|null} The parsed integer value, or null if not present or not a number.
 */
export function getParamInt(key) {
	const value = getParam(key);

	if (value === null) return null;

	const parsed = parseInt(value, 10);

	return Number.isNaN(parsed) ? null : parsed;
}
